import { DocumentViewerModule } from './../documents/documentViewer/documentViewer.module';
import { HeaderModule } from './../components/common/header/header.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';


import { WaitLoadingModule } from '../components/common/waitLoading/waitLoading.module';

import { mainViewComponent } from './main-view.component';
import { favouritesComponent } from './favourites.component';
import { widgetComponent } from './widget.component';
import { chartComponent } from './chart.component';
import { taskCountComponent } from './taskCount.component';
import { columnDragComponent } from './columnDrag.component';
import { auditUserComponent } from '../auditUser/audit.user.component';

import { DossierDetailModule } from '../dossiers/components/dossierDetail.module';
import { DivisionDetailModule } from '../dossiers/components/divisionDetail.module';
import { AuditUserModule } from '../auditUser/audit.user.module';
import { MainPipes } from '../pipes/main-pipes-module';
import { widgetsColumn } from './widgets-column.component';
import { widgetContainerComponent } from './widget-container.component';
import { welcomeNotesComponent } from '../components/common/welcomeNotes/welcomeNotes.component';
import { taskProcurementCommitteeComponent } from './taskProcurementCommittee.component';
import { TasksModule } from '../tasks/tasks.module';
import { tasksListComponent } from '../tasks/tasksList.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { sessionCountComponent } from './sessionCount.component';
import { sysTimeComponent } from './sysTime.component';
import { TableComponentModule } from './table.module';
import { TableModule } from 'primeng-lts/table';
import { DropdownModule } from 'primeng-lts/dropdown';
import { InputSwitchModule } from 'primeng-lts/inputswitch';
import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { DocumentFileViewerModule } from '../documents/documentFileViewer/documentFileViewer.module';
import { PaginatorModule } from 'primeng-lts/paginator';
import { ProgressBarModule } from 'primeng-lts/progressbar';
import { ChartModule } from 'primeng-lts/chart';
import { FormPlycaModule } from '../components/forms/formPlyca.module';

@NgModule({
  declarations: [
    widgetContainerComponent,
    mainViewComponent,
    favouritesComponent,
    widgetComponent,
    taskCountComponent,
    sessionCountComponent,
    widgetsColumn,
    sysTimeComponent,
    chartComponent,
    columnDragComponent,
    taskProcurementCommitteeComponent
  ],
  imports: [
    MainPipes,
    CommonModule,
    RouterModule,

    DossierDetailModule,
    DivisionDetailModule,
    AuditUserModule,
    TasksModule,
    WaitLoadingModule,
    PanelModule,
    ScrollPanelModule,
    InputSwitchModule,
    TranslateModule,
    FormsModule,
    FormPlycaModule,
    DropdownModule,
    TableModule,
    TableComponentModule,
    DocumentViewerModule,
    HeaderModule,
    PaginatorModule,
    ProgressBarModule,
    ChartModule
  ]
})
export class MainViewModule { }
